// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-container.main-container[data-v-199a0ee6]{padding:40px 0 0}", ""]);
// Exports
module.exports = exports;
